import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ac6babe8&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=ac6babe8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6babe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac6babe8')) {
      api.createRecord('ac6babe8', component.options)
    } else {
      api.reload('ac6babe8', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ac6babe8&scoped=true", function () {
      api.rerender('ac6babe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/stadiumSystem/stadiumManagement/stadiumInfo/detail.vue"
export default component.exports